module.exports = __webpack_public_path__ + "img/LogoPartialWhite.428abff6.svg";